import { IRequestResult } from "../schemas/structure"
import { PartialViews, AppControllers, AppServices } from '../helpers/config_keys';

interface IDataUploadService {
    uploadForm(model?: string): angular.ui.bootstrap.IModalServiceInstance
}

class DataUploadService implements IDataUploadService {
    static $inject = ["$uibModal"];

    constructor(private $uibModal: angular.ui.bootstrap.IModalService) { }

    uploadForm(model?: string) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            size: 'lg',
            backdrop: false,
            templateUrl: PartialViews.DataUpload,
            controller: AppControllers.DataUploadCtrl,
            controllerAs: 'uploadFormVm',
            resolve: { SelectModel: () => { return model } }
        });
        return modalInstance;
    }

}

export { IDataUploadService, DataUploadService }


// WEBPACK FOOTER //
// ./app/data_upload/data_upload_service.ts